export default __webpack_public_path__ + "static/media/paint-pen.a04e8afc.jpeg";